import React, { forwardRef } from "react";
import { cn } from "./utils";

const Textarea = forwardRef((props, ref) => {
  const { className, ...rest } = props;

  return (
    <textarea
      ref={ref}
      className={cn(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:text-white",
        className
      )}
      {...rest}
    />
  );
});

Textarea.displayName = "Textarea";

export { Textarea };
